import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../Header/Header";
import { customStyle } from '@custom/Utils/utils';
import { _roleType } from '@custom/Utils/constants/appConstants';
import { buildingIcon, documentIcon, hospitalIcon } from '../../ui/assets/svgIcons/icon';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import dashboardApi from '@custom/rtk-apis/dashboard/dashboard';
import { Loader } from '@ohif/ui';
import { useTheme } from "../../ui/src/contextProviders"
import './dashboard.css';
import switchUserRole from '@custom/rtk-apis/user/switchRole';
import userDetails from '@custom/rtk-apis/user/userDetails';

const Dashboard = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { result } = useSelector((state: RootState) => state.dashboardResponse);
  const [role, setRole] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitchingRole, setIsSwitchingRole] = useState(false);
  const userId = sessionStorage.getItem('userId') || localStorage.getItem("userId");
  const [selectedRole, setSelectedRole] = useState<string>('');
  const [previousRole, setPreviousRole] = useState<string | null>(null);
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const userRole = sessionStorage.getItem('role') || localStorage.getItem('role');

    setRole(userRole);
    setIsLoading(true);

    const fetchData = async () => {
      try {
        await dispatch(dashboardApi({ userId }));
      } catch (error) {
        console.error('API call failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch, userId]);

  useEffect(() => {
    if (selectedRole && userId) {
      setIsSwitchingRole(true);
      dispatch(switchUserRole({
        userId,
        newRole: selectedRole,
        newType: 'USER'
      }))
        .unwrap()
        .then((response) => {
          sessionStorage.setItem('switchUserRole', JSON.stringify(response));
          const newRole = response?.result?.newRole || selectedRole;
          const newAccessToken = response?.result?.accessToken;
          if (newRole) {
            sessionStorage.setItem('role', newRole);
          } else {
            throw new Error('No valid role received from switchUserRole response');
          }
          if (newAccessToken) {
            sessionStorage.setItem('token', newAccessToken);
          } else {
            throw new Error('No accessToken received from switchUserRole response');
          }
          return dispatch(userDetails()).unwrap();
        })
        .then((userDetailsResponse) => {
          sessionStorage.setItem('userDetails', JSON.stringify(userDetailsResponse));
          const storedRole = sessionStorage.getItem('role');
          const storedToken = sessionStorage.getItem('token');
          if (storedRole === selectedRole && storedToken) {
            setRole(storedRole);
            setIsSwitchingRole(false);
            window.location.reload();
          } else {
            throw new Error('Role or token mismatch after switch');
          }
        })
        .catch((error) => {
          setIsSwitchingRole(false);
          setErrorMessage('Failed to switch role. Please try again.');
        });
    }
  }, [selectedRole, userId, dispatch]);

  useEffect(() => {
    const userDetailsDebug = sessionStorage.getItem('userDetails');
    if (userDetailsDebug) {
      const parsed = JSON.parse(userDetailsDebug);
      const role = parsed?.result?.previousRole;
      const type = parsed?.result?.previousType;
      if (role && type) {
        sessionStorage.setItem('previousRoleFlag', role);
        setPreviousRole(role);
      }
    } else {
      const storedRole = sessionStorage.getItem('previousRoleFlag');
      if (storedRole) {
        setPreviousRole(storedRole);
      }
    }
  }, []);

  const handleRedirect = (redirectTo) => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  };

  return (
    <div className='page' style={
      isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
      <Header title='Dashboard' isBack={false} />
      <div className='page__body'>
        <div>
           {(role === 'hospitalsuperadmin' || role === 'Admin') && (
          <div className="form__radio form__radio--gray flex-wrap justify-end gap-2">
            <div className="form__radio__option m-0">
              <input
                type="radio"
                name="switchRole"
                value="Radiologist"
                className="form__radio__input"
                checked={selectedRole === 'Radiologist'}
                onChange={() => setSelectedRole('Radiologist')}
              />
              <label htmlFor="radiologist" className="form__radio__label">Switch to Radiologist</label>
            </div>
            <div className="form__radio__option m-0">
              <input
                type="radio"
                name="switchRole"
                value="Pathologist"
                className="form__radio__input"
                checked={selectedRole === 'Pathologist'}
                onChange={() => setSelectedRole('Pathologist')}
              />
              <label htmlFor="pathologist" className="form__radio__label">Switch to Pathologist</label>
            </div>
          </div>
        )}
        {(role === 'Radiologist' || role === 'Pathologist') && previousRole === 'hospitalsuperadmin' && (
          <div className="form__radio form__radio--gray flex-wrap justify-end gap-2">
            <div className="form__radio__option m-0">
              <input
                type="radio"
                name="switchRole"
                value="hospitalsuperadmin"
                className="form__radio__input"
                checked={selectedRole === 'hospitalsuperadmin'}
                onChange={() => setSelectedRole('hospitalsuperadmin')}
              />
              <label htmlFor="hospitalsuperadmin" className="form__radio__label">Switch to Superadmin</label>
            </div>
          </div>
        )}
        {(role === 'Radiologist' || role === 'Pathologist') && previousRole === 'Admin' && (
          <div className="form__radio form__radio--gray flex-wrap justify-end gap-2">
            <div className="form__radio__option m-0">
              <input
                type="radio"
                name="switchRole"
                value="Admin"
                className="form__radio__input"
                checked={selectedRole === 'Admin'}
                onChange={() => setSelectedRole('Admin')}
              />
              <label htmlFor="Admin" className="form__radio__label">Switch to Admin</label>
            </div>
          </div>
        )}

          {/* Today's Data */}
          <div className=" cursor-pointer">
            <h3 className='dashboardWrap-title' style={
              isDarkMode ? { color: '#FFFFFF', } : { color: '#000000', }
            }>Today</h3>
            <div className="dashboardWrap darshboard-list">
              {result?.list && result.list.length > 0 ? (
                result.list.map((item, index) => {
                  if (item.name === "User" && role === _roleType.frontDesk) {
                    return null;
                  }
                  const currentMonthData =
                    item.currentMonthUsers ??
                    item.currentMonthPatients ??
                    item.currentMonthAppointment ??
                    item.currentMonthReports ??
                    item.currentMonthHospital ??
                    item.currentMonthTeleradiologyHospital ??
                    item.currentMonthWorklist ??
                    0;
                  return (
                    <div
                      key={`current-month-${index}`}
                      onClick={() => handleRedirect(item.redirectTo)}
                      className="dashboardWrap-item"
                    >
                      <div className='content'>
                        <h2>{currentMonthData}</h2>
                        <p>{item.name}</p>
                      </div>
                      <div className="icon">
                        <img src={item.iconName === "hospitalIcon" ? hospitalIcon : item.iconName === "documentIcon" ? documentIcon : buildingIcon} alt={item.name} />
                      </div>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </div>
          {/* Overall Data */}
          <div className=" cursor-pointer">
            <h3 className='dashboardWrap-title' style={
              isDarkMode ? { color: '#FFFFFF' } : { color: '#000000' }
            }>Overall</h3>
            <div className='dashboardWrap darshboard-list'>
              {result?.list && result.list.length > 0 ? (
                result.list.map((item, index) => {
                  if (item.name === "User" && role === _roleType.frontDesk) {
                    return null;
                  }
                  return (
                    <div
                      key={`overall-${index}`}
                      onClick={() => handleRedirect(item.redirectTo)}
                      className="dashboardWrap-item"
                    >
                      <div className='content'>
                        <h2>{item.count}</h2>
                        <p>{item.name}</p>
                      </div>
                      <div className="icon">
                        <img src={item.iconName === "hospitalIcon" ? hospitalIcon : item.iconName === "documentIcon" ? documentIcon : buildingIcon} alt={item.name} />
                      </div>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <Loader
        isLoaderOpen={isLoading || isSwitchingRole}
        title={"Loading"}
      />
    </div>
  );
}

export default Dashboard;
function setErrorMessage(arg0: string) {
  throw new Error('Function not implemented.');
}
